import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import HeroImg from '../../assets/images/heros.jpg';
import Button from '../Button';
import SocialMediaArrow from '../../assets/images/social-media-arrow.svg';
import ScrollDownArrow from '../../assets/images/scroll-down-arrow.svg';
import PText from '../PText';
import {AnimationText} from "../../styles/AnimationText";


const HeroStyles = styled.div`



  .hero {
    height: 100vh;
    min-height: 1000px;
    width: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

  }


  .hero__par {
    color: white !important;

  }

  .hero__span {
    font-size: 35px;

  }

  .hero__heading {

    font-size: 1.4rem;
    z-index: 2;
    margin: 0 auto;
    text-align: center;
    position: absolute;
    width: 100%;
    top: -17%;


    span {
      display: inline-block;

    }

    .hero__name {
      font-family: 'Montserrat SemiBold', sans-serif;
      font-size: 7rem;
      color: var(--white);
    }
  }


  /**
    * animation
   */

  .hero__img {
    //animation
    overflow: hidden;
  }

  .container img {
    //animation
    transition: all 1s ease-out;
  }

  .container {
    position: relative;
    z-index: 1;
  }

  .hero__img {
    max-width: 900px;
    width: 100%;
    height: 600px;
    margin: 0 auto;
    border: 2px solid white;
  }

  .container img:hover {
    //animation
    transform: scale(1.1);
  }

  /**
    * animation
   */

  .hero__info {
    position: absolute;
    top: 38rem;
    margin: 0 auto;
    width: 100%;
    padding: 10px;
  }

  .hero__social,
  .hero__scrollDown {
    display: flex;
    flex-direction: column;
    gap: 3rem;
    position: absolute;

    bottom: 40px;
    width: 50px;
  }

  .hero__social {
    left: 50px;
  }

  .hero__scrollDown {
    right: 50px;
  }

  .hero__social__indicator,
  .hero__scrollDown {
    width: 50px;

    p {
      font-size: 1.6rem;
      transform: translateY(-70px) rotate(90deg);
      letter-spacing: 0.7rem;
      text-transform: uppercase;
    }

    img {
      max-height: 45px;
      width: 16px;
      margin: 0 auto;
      object-fit: contain;
    }
  }

  .hero__scrollDown {
    img {
      max-height: 70px;
    }
  }

  .hero__social__text {
    ul {
      li {
        margin-bottom: 2rem;

        a {
          display: inline-block;
          font-size: 1.6rem;
          transform: rotate(-90deg);
          letter-spacing: 5px;
          margin-bottom: 2rem;
          text-decoration: none;
          color: white;
        }
      }
    }
  }


  @media only screen and (max-width: 1024px) {
    .hero__social {
      display: none;

      p {
        display: none
      }

      img {
        display: none
      }
    }

    .hero__scrollDown {
      display: none;

      p {
        display: none;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .hero {
      margin-top: 20vh;
      height: 0%;
      min-height: 0px;

    }

    .hero__heading {
      top: -20%
    }

    .hero__span {
      font-size: 39px;
    }

    .hero__img {
      height: 500px;
    }

    .hero__info {
      top: 29rem;
    }

  }


  @media only screen and (max-width: 425px) {
    //font-size: 1.4rem;
    .hero__heading {
      top: -18%
    }

    .hero__span {
      font-size: 35px;
    }

    .hero__img {
      height: 500px;
    }


  }

  //
  @media only screen and (max-width: 375px) {
    padding: 1rem 0;
    .hero__heading {
      top: -15.8%
    }

  }

  @media only screen and (max-width: 320px) {
    .hero__heading {
      top: -15.8%
    }

    .hero__span {
      top: 35px
    }
  }
`


export default function HeroSection() {


    const [letterClass, setLetterClass] = useState('text-animate')
    const nameArray = ['M', 'a', 'k', 's', '_', 'E', 'r', 'e', 'm', 'i', 'n']
    useEffect(() => {
        try {
            let animation = setTimeout(() => {
                setLetterClass('text-animate-hover')
            }, 4000)
            return () => {
                clearTimeout(animation);
            }
        } catch (error) {
            console.log(error)
        }
    }, [])

    return (
        <HeroStyles>
            <div className='hero'>
                <div className='container'>
                    <div className="hero__main">
                        <h1 className='hero__heading'>
                            <span className='hero__span'>Hello, This is</span>
                            <AnimationText
                                letterClass={letterClass}
                                strArray={nameArray}
                                idx={22}
                            />
                        </h1>
                    </div>
                    <div className='hero__img'>
                        <picture>
                            <source srcSet={HeroImg} type="image/avif"/>
                            <img src={HeroImg} alt="hero"/>
                        </picture>
                        {/*<img src={HeroImg} alt=''/>*/}
                    </div>
                    <div className='hero__info'>
                        <PText styly="hero__par">
                            I am a front-end developer of websites, I create professional websites.
                            I love art and always try to show the unique views of the audience with my design.
                        </PText>
                        <Button
                            btnText='see my works' btnLink='/projects'/>
                    </div>
                    <div className='hero__social'>
                        <div className='hero__social__indicator'>
                            <p>Follow</p>
                            <img src={SocialMediaArrow} alt='icon'/>
                        </div>
                        <div className='hero__social__text'>
                            <ul>
                                <li>
                                    <a
                                        href='https://t.me/eremin_maksim_official'
                                        target='_blank'
                                        rel='noreferrer'
                                    >
                                        TL
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href='https://wa.me/79101170018'
                                        target='_blank'
                                        rel='noreferrer'
                                    >
                                        WP
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href='https://www.instagram.com/pro100luckys'
                                        target='_blank'
                                        rel='noreferrer'
                                    >
                                        IN
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href='https://github.com/ereminmaksim'
                                        target='_blank'
                                        rel='noreferrer'
                                    >
                                        GH
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className='hero__scrollDown'>
                        <p>Scroll</p>
                        <img src={ScrollDownArrow} alt='ScrollDown Arrow'/>
                    </div>
                </div>
            </div>
        </HeroStyles>
    );
}
